import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

// Connects to data-controller="submissions-chart"
// Renders a stacked bar chart of submissions over the last 30 days, one coloured series per team
// (top teams + "Other"). Data comes from Metrics::SubmissionsTimeline via the `data` value:
//   { categories: [...30 labels], series: [{ name, data: [...30] }], colours: [...] }
// Also drives the dashboard's Submissions card (TASK-226.9), which prints its
// own legend above the chart (legend: false) and its own empty-state copy.
export default class extends Controller {
  static values = {
    data: Object,
    legend: { type: Boolean, default: true },
    emptyText: { type: String, default: "No submissions in the last 30 days" }
  }

  connect() {
    const { categories = [], series = [], colours = [] } = this.dataValue

    this.chart = new ApexCharts(this.element, {
      chart: {
        type: "bar",
        height: 320,
        stacked: true,
        toolbar: { show: false },
        fontFamily: "inherit",
      },
      series,
      colors: colours,
      plotOptions: { bar: { columnWidth: "65%", borderRadius: 2 } },
      dataLabels: { enabled: false },
      legend: { show: this.legendValue, position: "bottom", fontSize: "12px" },
      xaxis: {
        categories,
        tickAmount: 10,
        axisBorder: { show: false },
        axisTicks: { show: false },
        labels: { rotate: 0, style: { colors: "#6b7280", fontSize: "11px" } },
      },
      yaxis: { labels: { style: { colors: "#6b7280", fontSize: "11px" } } },
      grid: { borderColor: "#e5e7eb", strokeDashArray: 4 },
      tooltip: { shared: true, intersect: false },
      noData: { text: this.emptyTextValue, style: { color: "#6b7280" } },
      // A phone can't fit 12 flat week labels: tilt them and let ApexCharts
      // drop the ones that would still collide.
      responsive: [{
        breakpoint: 640,
        options: { xaxis: { tickAmount: 6, labels: { rotate: -45, rotateAlways: true, hideOverlappingLabels: true } } },
      }],
    })

    this.chart.render()
  }

  disconnect() {
    this.chart?.destroy()
    this.chart = null
  }
}
